import React, { useEffect, useId, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

AccordionItem.propTypes = {
    item: PropTypes.object,
};

/**
 * `react-bootstrap-accordion` savolni qattiq kodlangan <h2> ichida chiqaradi.
 * Bo'lim sarlavhasi ham h2 bo'lgani uchun savollar u bilan bir darajada
 * turib qolardi. Shu sabab kutubxona bilan bir xil DOM va CSS klasslarini
 * saqlagan holda, sarlavha tegi h3 ga tushirildi.
 *
 * `h2` klassi faqat vizual o'lchamni avvalgidek saqlash uchun — teg h3.
 */
function AccordionItem(props) {
    const { item } = props;

    const { t } = useTranslation();

    const [open, setOpen] = useState(Boolean(item.show));
    const bodyRef = useRef(null);
    const uid = useId().replace(/:/g, '');

    useEffect(() => {
        if (item.show) setOpen(true);
    }, [item.show]);

    return (
        <div className="accordion-item">
            <h3 className="accordion-header h2" id={`heading-${uid}`}>
                <button
                    className={`accordion-button${open ? '' : ' collapsed'}`}
                    type="button"
                    aria-expanded={open}
                    aria-controls={`collapse-${uid}`}
                    onClick={() => setOpen((v) => !v)}
                >
                    {t(item.title)}
                </button>
            </h3>
            <div
                id={`collapse-${uid}`}
                aria-labelledby={`heading-${uid}`}
                className="accordion-collapse"
                style={
                    open
                        ? {
                              height: bodyRef.current?.clientHeight,
                              transition: 'height 0.2s ease',
                              overflow: 'hidden',
                          }
                        : { height: 0, transition: 'height 0.2s ease', overflow: 'hidden' }
                }
            >
                <div className="accordion-body" ref={bodyRef}>
                    <p className="toggle-content">{t(item.content)}</p>
                </div>
            </div>
        </div>
    );
}

export default AccordionItem;
